// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subcareerContainer{
    display: flex;
    column-gap: 10px;
}
.subcareerContainer-one{
    width: 33%;
}

.careerItem {
    display: flex;
    height: max-content;
    justify-content: space-between;
    align-items: center;
    padding: 5%;
    border: 1px solid #ccc;
    border-radius: 10px;
}
.careerItem * {
   box-sizing: border-box;
}

.careerContent>:nth-child(1){
    margin: 0px;
    font-size: 20px;
    font-weight: 500;
    line-height: 24.2px;
    color: rgba(39, 36, 34, 1);
}

/* Main Div2 */
.careerContent>:nth-child(2){
    margin-top: 4%;
    font-size: 16px;
    font-weight: 400;
    line-height: 19.36px;
    color: #7A7D9C;
}

.careerContent>:nth-child(2) span{
    color: #0B63E5;
    font-size: 16px;
    font-weight: 400;
    line-height: 19.36px;
}

.careerContent>:nth-child(3){
    height: 44px;
    font-size: 15px;
    font-weight: 400;
    line-height: 21px;
    margin-bottom: 0px;
}

.careerArrow {
    display: flex;
    align-items: center;
    padding: 1px;
    border: 1px 0px 0px 0px;
    width: 115px;
    height: 60px;
}
.careerArrow img{
    width: 100%;
}

.subcareerContainer-two{
    width: 60%;
    padding: 1%;
}

.JobDescription{
    height: 25px;
    font-family: Plus Jakarta Sans;
    font-size: 27px;
    font-weight: 600;
    line-height: 25px;
}
.JobDescription span{
    color: rgba(46, 166, 143, 1);
}
.JobLocation{
    width: 257px;
    font-family: Plus Jakarta Sans;
    font-size: 20px;
    font-weight: 700;
    line-height: 25.79px;
}

.Jobresponsibility{
    font-family: Plus Jakarta Sans;
    font-size: 20px;
    font-weight: 700;
    line-height: 25.79px;
    margin-bottom: 25px;
}
.Jobresponsibility p{
    margin-bottom: 25px;
}
.Jobresponsibility ul {
    font-family: Plus Jakarta Sans;
    font-size: 15.12px;
    font-weight: 400;
    line-height: 30.95px;
    margin: 0px;
}

.JobSkill{
    font-family: Plus Jakarta Sans;
    font-size: 20px;
    font-weight: 700;
    line-height: 25.79px;
}
 
.JobSkill p{
    margin-bottom: 25px;
}

.JobSkill ul{
    font-family: Plus Jakarta Sans;
    font-size: 15.12px;
    font-weight: 400;
    line-height: 30.95px;
    margin: 0px;
}

.Linetag{
    color: #0B63E5;
    border: 1px solid;
    margin-top: -15px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Career/SubCareer.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,mBAAmB;AACvB;AACA;GACG,sBAAsB;AACzB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA,cAAc;AACd;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,YAAY;AAChB;AACA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;AAChC;AACA;IACI,YAAY;IACZ,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,iBAAiB;AACrB","sourcesContent":[".subcareerContainer{\r\n    display: flex;\r\n    column-gap: 10px;\r\n}\r\n.subcareerContainer-one{\r\n    width: 33%;\r\n}\r\n\r\n.careerItem {\r\n    display: flex;\r\n    height: max-content;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 5%;\r\n    border: 1px solid #ccc;\r\n    border-radius: 10px;\r\n}\r\n.careerItem * {\r\n   box-sizing: border-box;\r\n}\r\n\r\n.careerContent>:nth-child(1){\r\n    margin: 0px;\r\n    font-size: 20px;\r\n    font-weight: 500;\r\n    line-height: 24.2px;\r\n    color: rgba(39, 36, 34, 1);\r\n}\r\n\r\n/* Main Div2 */\r\n.careerContent>:nth-child(2){\r\n    margin-top: 4%;\r\n    font-size: 16px;\r\n    font-weight: 400;\r\n    line-height: 19.36px;\r\n    color: #7A7D9C;\r\n}\r\n\r\n.careerContent>:nth-child(2) span{\r\n    color: #0B63E5;\r\n    font-size: 16px;\r\n    font-weight: 400;\r\n    line-height: 19.36px;\r\n}\r\n\r\n.careerContent>:nth-child(3){\r\n    height: 44px;\r\n    font-size: 15px;\r\n    font-weight: 400;\r\n    line-height: 21px;\r\n    margin-bottom: 0px;\r\n}\r\n\r\n.careerArrow {\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 1px;\r\n    border: 1px 0px 0px 0px;\r\n    width: 115px;\r\n    height: 60px;\r\n}\r\n.careerArrow img{\r\n    width: 100%;\r\n}\r\n\r\n.subcareerContainer-two{\r\n    width: 60%;\r\n    padding: 1%;\r\n}\r\n\r\n.JobDescription{\r\n    height: 25px;\r\n    font-family: Plus Jakarta Sans;\r\n    font-size: 27px;\r\n    font-weight: 600;\r\n    line-height: 25px;\r\n}\r\n.JobDescription span{\r\n    color: rgba(46, 166, 143, 1);\r\n}\r\n.JobLocation{\r\n    width: 257px;\r\n    font-family: Plus Jakarta Sans;\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n    line-height: 25.79px;\r\n}\r\n\r\n.Jobresponsibility{\r\n    font-family: Plus Jakarta Sans;\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n    line-height: 25.79px;\r\n    margin-bottom: 25px;\r\n}\r\n.Jobresponsibility p{\r\n    margin-bottom: 25px;\r\n}\r\n.Jobresponsibility ul {\r\n    font-family: Plus Jakarta Sans;\r\n    font-size: 15.12px;\r\n    font-weight: 400;\r\n    line-height: 30.95px;\r\n    margin: 0px;\r\n}\r\n\r\n.JobSkill{\r\n    font-family: Plus Jakarta Sans;\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n    line-height: 25.79px;\r\n}\r\n \r\n.JobSkill p{\r\n    margin-bottom: 25px;\r\n}\r\n\r\n.JobSkill ul{\r\n    font-family: Plus Jakarta Sans;\r\n    font-size: 15.12px;\r\n    font-weight: 400;\r\n    line-height: 30.95px;\r\n    margin: 0px;\r\n}\r\n\r\n.Linetag{\r\n    color: #0B63E5;\r\n    border: 1px solid;\r\n    margin-top: -15px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
